import * as types from './types';

export const addToCart = (product, quantity, variationId = null) => ({
  type: types.ADD_TO_CART,
  payload: { product, quantity, variationId },
});

export const removeFromCart = (productId, variationId = null) => ({
  type: types.REMOVE_FROM_CART,
  payload: { productId, variationId },
});

export const updateCartQuantity = (productId, quantity, variationId = null) => ({
  type: types.UPDATE_CART_QUANTITY,
  payload: { productId, quantity, variationId },
});

export const clearCart = () => ({
  type: types.CLEAR_CART,
});
